$(document).ready(function()
{

  var acc = document.getElementsByClassName("toggleTitle");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      this.classList.toggle("arrow-open");
      var toggleContent = this.nextElementSibling;
      if (toggleContent.style.display === "block") {
        toggleContent.style.display = "none";
      } else {
        toggleContent.style.display = "block";
      }
    });
  }
})

function navigationMenuSection(){
  const navigationMenus = document.querySelectorAll('.navigation-menu');
  console.log('navigationMenus', navigationMenus);

  navigationMenus.forEach(item => {
      const menuTrigger = item.querySelector('.mobile-menu-trigger');

      menuTrigger.addEventListener('click', () => {
        console.log('click insection-blocks__accordion-item ')
        navigationMenus.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
          }
        });

        item.classList.toggle('active');
      });
  });
}

document.addEventListener('DOMContentLoaded', (evt) => {
  navigationMenuSection();

  var isSafari = /^Apple/.test(navigator.vendor) && !/CriOS|FxiOS/.test(navigator.userAgent);
  
  if (isSafari) {
      document.querySelector('body').classList.add('is-safari');
  }
})

// Fix PDP Button on scroll
function addtoCartCheckScroll() {
  var scrollPosition = window.scrollY;
  var PDPaddtoCartForm = document.querySelector("body:not(.suffix-personalization) .block-buy-buttons.block-buy-buttons.product-block");
  
  if (PDPaddtoCartForm) {
      var elementOffset = PDPaddtoCartForm.getBoundingClientRect().top + window.scrollY;
      var distance = elementOffset + 50; // 50px below the element

      if (scrollPosition > distance) {
        PDPaddtoCartForm.classList.add("make-fix");
      } else {
        PDPaddtoCartForm.classList.remove("make-fix");
      }
  }
}
function addtoCartBlockClickWhenFixed( ele ) {

  
}

window.addEventListener("scroll", addtoCartCheckScroll);

var PDPaddtoCartBtn = document.querySelector(".block-buy-buttons.block-buy-buttons.product-block button");

if(PDPaddtoCartBtn){
  PDPaddtoCartBtn.addEventListener("click", function( event ){
    var PDPaddtoCartForm = PDPaddtoCartBtn.closest(".block-buy-buttons.product-block");
  
    if(PDPaddtoCartForm && PDPaddtoCartForm.classList.contains('make-fix')){
      event.preventDefault();
  
      if (PDPaddtoCartForm) {
        document.querySelector('.product-grid__content.product--description').scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  
  });
}

// GCW Recs: scroll controls + auto-bind when BR renders
(function () {
  function init(container) {
    if (!container || container.dataset.gcwRecsBound) return;
    const scroller = container.querySelector('.gcw-recs__scroller');
    if (!scroller) return;

    const prev = container.querySelector('.gcw-recs__prev');
    const next = container.querySelector('.gcw-recs__next');
    const item = scroller.querySelector('.gcw-recs__item, .grid-item');

    const gap = () => {
      const cs = getComputedStyle(scroller);
      return parseFloat(cs.columnGap || cs.gap || 0) || 0;
    };
    const step = () => {
      const w = item ? item.getBoundingClientRect().width : scroller.clientWidth * 0.8;
      return w + gap();
    };

    prev && prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
    next && next.addEventListener('click', () => scroller.scrollBy({ left:  step(),  behavior: 'smooth' }));

    container.dataset.gcwRecsBound = '1';
  }

  function scan(root = document) {
    root.querySelectorAll('.gcw-recs').forEach(init);
  }

  // DOM ready + Shopify editor section events
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', () => scan());

  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => scan(e.target));

  // Rebind when Bloomreach injects/upgrades the widget
  const mo = new MutationObserver(muts => muts.forEach(m => scan(m.target)));
  mo.observe(document.body, { childList: true, subtree: true });
})();